export default function ProgressBarBottom({ currentStep, totalSteps = 7 }) {
  const reductionPerStep = 5; // percent to reduce from each intermediate step
  const stepIndex = currentStep; // zero-based
  const lastIndex = totalSteps; // treat the final step as the one that shows 100% (after all reductions)
  const basePercent = ((stepIndex + 1) / totalSteps) * 100;

  let progressPercent;
  if (stepIndex < lastIndex) {
    progressPercent = Math.max(0, basePercent - reductionPerStep);
  } else {
    // Final step: show full 100% (includes the reserved reductions from prior steps)
    progressPercent = 100;
  }

  return (
    <div>
      <div
        className={`bg-[#E6E6E6] h-[4.23px] md:h-[6px] w-full rounded-full overflow-hidden`}
      >
        <div
          className="bg-[#55AB26] h-full transition-all duration-300"
          style={{ width: `${progressPercent}%` }}
        ></div>
      </div>

      <p className="text-[#7876A1BF] text-right md:text-[14px] mt-[8px] text-[8px] font-normal leading-[1]">
        Step {currentStep + 1} of {totalSteps}
      </p>
    </div>
  );
}
